<div class="performace-list-item">
  <a [href]="generateHref(listItem?.eventCode, currentRegion, currentLang, listItem?.keyUrlText)">
    <div class="performance-listing">
      <div class="date-box date-divider"
        *ngIf="(lastDate|localizedDate:dayFormat) == (firstDate|localizedDate:dayFormat)">
        <div class="date-box"><span class="day">{{ date|localizedDate:dayFormat }}</span> <span class="month">{{
            date|localizedDate:monthFormat }}</span></div>
      </div>
      <div class="date-box" *ngIf="(lastDate|localizedDate:dayFormat) !== (firstDate|localizedDate:dayFormat)">
        <span><mat-icon>calendar_month</mat-icon></span>
        <!--<span class="day">{{lastDate|localizedDate:dayFormat}}</span> <span class="month">{{lastDate|localizedDate:monthFormat}}</span>-->
      </div>
      <div class="divider">&nbsp;</div>
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="5px" class="info-group">
          <!-- <mat-icon class="time-icon">schedule</mat-icon> --> <span class="event-name">{{ listItem?.eventName
            }}</span>
          <!-- <span class="time">{{date|localizedDate:timeFormat}}</span> -->
          <mat-basic-chip class="status" [ngClass]="statusClasses()">{{ ('performance.status.' + listItem?.status) | translate }}</mat-basic-chip>
        </div>
        <div fxLayout="row" class="performance-listing-venue"> {{ listItem?.venueName }}, {{ listItem?.venueCity }}
        </div>
        <div fxLayout="row" class="performance-listing-info" [innerHTML]="eventTitleInfo">
        </div>
        <div fxLayout="row" class="performance-listing-price" *ngIf="listItem?.minPrice && listItem.minPrice !== '0'">
          <mat-icon>local_offer</mat-icon>
          <span><small class="price-prefix">{{ 'home.labels.pricePrefix' | translate }}</small>{{ listItem?.minPrice | customCurrency }}<small class="price-suffix">{{ 'home.labels.priceSuffix' | translate }}</small></span>
        </div>
      </div>
      <!-- <div class="campaign-title-holder" *ngIf="listItem?.campaignTitle"> <mat-basic-chip class="campaign-title">{{listItem?.campaignTitle}}</mat-basic-chip> </div> <div class="chevron-right" *ngIf="listItem?.active"> <mat-icon>chevron_right</mat-icon> </div> -->
      <span *ngIf="listItem.status === 's01_onsale'" class="chevron-right buy-button">
        <span class="desktop-buy">{{ 'shared.labels.buy'| translate }}</span>
        <mat-icon class="mobile-chevron">chevron_right</mat-icon>
      </span>
    </div>
  </a>
</div>